import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import loader from './loader';
import usersReducer from './users';
import productReducer from './products';
import pageReducer from './page';
import adminReducer from './admin';
import feedbackReducer from './feedback';
import orderReducer from './order';
import orderFormReducer from './orderFormReducer';

const reducers = combineReducers({
    loader,
    usersReducer,
    productReducer,
    pageReducer,
    adminReducer,
    feedback: feedbackReducer,
    order: orderReducer,
    orderForm: orderFormReducer
})
const persistConfig = {
    key: "key",
    root: "root",
    storage,
  };


const rootReducer = persistReducer(persistConfig, reducers);
export default rootReducer;